<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-19 16:25:11
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <!-- <div slot="header">
        <div class="seachBtn">
          <el-button type="primary">搜索</el-button>
          <el-button type="primary">重置</el-button>
        </div>
      </div>-->
      <div>
        <div class="adddBtnBox">
          <el-button>添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" border="true" height="600">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="time" label="推送时间" width="180"></el-table-column>

          <el-table-column prop="comp" label="推送单位"></el-table-column>

          <el-table-column prop="address" label="推送地址"></el-table-column>
          <el-table-column prop="pro" label="推送产品"></el-table-column>
          <el-table-column prop="address" label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">推送</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination> -->
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input1: "",
      tableData: [
        {
          time: "2023-12-08 12:01:56",
          comp: "崇州农业农村局",
          address: "ftp:\\testProWeb",
          pro: "崇州农业气象日报1"
        },
        {
          time: "2023-12-08 12:02:11",
          comp: "崇州农业农村局",
          address: "ftp:\\testProWeb",
          pro: "崇州农业气象日报2"
        },
        {
          time: "2023-12-09 08:55:56",
          comp: "崇州农业农村局",
          address: "ftp:\\testProWeb",
          pro: "崇州农业气象日报3"
        },
        {
          time: "2023-12-09 12::56",
          comp: "崇州农业农村局",
          address: "ftp:\\testProWeb",
          pro: "崇州农业气象日报4"
        }
      ]
    };
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
</style>